import * as d3 from "d3";
import { useEffect, useRef } from "react";
import React from 'react';

type ColorLegendProps = {
  height: number;
  width: number;
  colorScale:  d3.ScaleQuantize<string, never>;
};

const COLOR_LEGEND_MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };

// Define a color scale with 6 colors plus white for the 0 value

export const ColorLegend = ({
  height,
  width,
  colorScale,
}: ColorLegendProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const boundsWidth = width;
  const boundsHeight = height;

  // Number of color bands
  const numBands = 6; // Excluding white
  const colorBandHeight = boundsHeight / (numBands ); // +1 for white

  // Vertical scale for ticks
  const yScale = [-54, -36, -18, 0, 18, 36, 54]//[colorScale.domain()[0],  colorScale.thresholds(), colorScale.domain()[1]];///d3.scaleLinear().range([0, boundsHeight]).domain([-50, 50]);
  // console.log(yScale);
  // Render the color bands for the legend
  const colorBands = Array.from({ length: numBands }, (_, i) => {
    const value = yScale[i]//.invert(i * (boundsHeight / (numBands + 1)));
    // console.log(value)
    return (
            <g key={i}>
        <rect
          x={0}
          y={boundsHeight - (i * colorBandHeight)}
          width={boundsWidth}
          height={colorBandHeight}
          fill={colorScale(value)}
        />

      </g>
    );
  });

    // Render border labels for color bands
    const borderLabels = Array.from({ length: numBands + 1 }, (_, i) => {
      const value = yScale[i];//invert(i * (boundsHeight / (numBands + 1)));
      return (
        <text
          key={i}
          x={boundsWidth + 5}  // Position text to the right of the rectangle
          y={boundsHeight - (i * colorBandHeight) + colorBandHeight } // Center vertically
          fontSize={10}
          textAnchor="start"  // Align text to the start (left)
          dominantBaseline="middle" // Center text vertically
        >
          {value}%  {/* Display the value rounded to 0 decimal places */}
        </text>
      );
    });


  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");

    if (!context) {
      return;
    }

    // Clear the canvas before drawing
    context.clearRect(0, 0, boundsWidth, boundsHeight);

  }, [width, height, colorScale, boundsWidth, boundsHeight]);

  return (
    <div style={{ width, height }}>
      <div
        style={{
          position: "relative",
          transform: `translate(${COLOR_LEGEND_MARGIN.left}px, ${COLOR_LEGEND_MARGIN.top}px)`,
        }}
      >
        <canvas ref={canvasRef} width={boundsWidth} height={boundsHeight} />
        <svg
          width={boundsWidth}
          height={boundsHeight}
          style={{ position: "absolute", top: 0, left: 0, overflow: "visible" }}
        >
          {colorBands}
          {borderLabels}
          {/* {triangle} */}
        </svg>
      </div>
    </div>
  );
};

